import { Upload } from 'antd'
import Flex from 'components/Flex'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const CandiadateFlex = styled(Flex)`
  border: 1px solid ${COLORS.GREY_T_90};
  border-radius: 10px;
  padding: 15px;
  display: flex;
  justify-content: space-between;
`
export const DocFlex = styled(Flex)`
  margin-left: 5px;
`
export const SelectDiv = styled.div`
  margin: 30px 0 25px;
`
export const CandidateInfo = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_700};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_20};
`
export const TemolateDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 20px;
  color: ${COLORS.GREY_T_60};
`
export const UploadFlex = styled(Flex)`
  margin: 25px 0 20px 0;
  border: 1px dashed ${COLORS.BLUE_T_80};
  border-radius: 8px;
  background: ${COLORS.BLUE_T_97};
  height: 150px;

  padding: 30px;
  cursor: pointer;
  
  &:hover {
    border: 1px dashed #159cd1;
    background: ${COLORS.BLUE_T_98};
  }
`
export const UploadFileDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_BASE};
  line-height: 20px;
  color: #30475e;
  margin-bottom: 5px;
  text-align: center;
`
export const FileNameDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: #b7bfc7;
  text-align: center;
`
export const UploadIconDiv = styled.div`
  margin-bottom: 15px;
  text-align: center;
`
export const StyledUpload = styled(Upload)`
  .ant-upload {
    width: 100%;
  }
`
export const FooterFlex = styled(Flex)`
  gap: 8px;
`
export const UploadMsgFlex = styled(Flex)`
  height: 100%;
`
export const ResultDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.GREY_T_20};
  margin: 5px 0;
`
export const FileInfoDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  text-align: center;
  color: ${COLORS.GREY_T_60};
`
export const FileTextSpan = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_400};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_60};
`
export const ResultIconDiv = styled.div`
  text-align: center;
  margin-bottom: 10px;
`
export const ButtonDiv = styled.div`
  margin: 17px;
`

export const Wrapper = styled.div`
  padding-top: 0px;
`

export const Divider = styled.div`
  margin-top: 20px;
  border: 1px solid #ecedf0;
`
export const HeadTextWrap = styled(Flex)`
  margin-top: 30px;
  margin-bottom: 30px;
  font-weight: 600;
  font-size: 16px;
  color: #202020;
`

export const ErrorWrap = styled(Flex)`
  margin-top: 10px;
  flex-direction: row;
  align-items: center;
  padding: 10px 15px;
  background: #fafafb;
  border: 1px solid #e6e7ea;
  border-radius: 8px;
`

export const SubText = styled.div`
  font-weight: 400;
  font-size: 14px;
  color: #4d566e;
  padding-left: 10px;
  margin-top: ${props => props?.margin && '-10px'};
`
export const ListItem = styled.li`
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #4d566e;
  line-height: 20px;
  padding-left: 10px;
`
export const Wrap = styled(Flex)`
  padding-top: 11px;
`

export const IconWrapper = styled(Flex)`
  margin-top: 30px;
  cursor: pointer;
  pointer-events: ${props => (props?.disable ? 'none' : 'auto')};
`
export const SpinStyle = styled(Flex)``

export const ScoreFlex = styled(Flex)`
  gap: 50px;
  align-items: flex-start;
  justify-content: flex-start;
  display: flex;
`
export const RemarksDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_SM};
  line-height: 18px;
  color: ${COLORS.GREY_T_30};
  margin: ${props => (props?.isMargin ? '0px 0 5px 0' : '15px 0 10px 0')};
`
